export default function resolvePath() {
    if (typeof window !== `undefined`) {
        return window.location.pathname;
    }
    return ``;
}